<div class="section-page">
  <div class="container">
    <div class="row">
      <div class="col text-center">
        <h2>Começando agora no <strong class="strong-blue">Automation</strong>?</h2>
        <h2>As <strong>Soluções Guiadas</strong> te ajudam a dar os primeiros passos</h2>
      </div>
    </div>

    <div class="tour-grid">
      <a
        (click)="redirectArticle('/tour/4000178849-dinamize-automation-comecando-do-zero/article/4000172997-como-configurar-os-registros-dns')"
        (keydown.enter)="redirectArticle('/tour/4000178849-dinamize-automation-comecando-do-zero/article/4000172997-como-configurar-os-registros-dns')"
        (keydown.space)="redirectArticle('/tour/4000178849-dinamize-automation-comecando-do-zero/article/4000172997-como-configurar-os-registros-dns')"
        class="button"
        tabindex="0"
        role="button"
        class="button"
      >
        <div class="box text-center div-tour">
          <div class="tour-number">1</div>
          <h3>Começando do zero</h3>
        </div>
      </a>

      <a
        (click)="redirectArticle('tour/4000178850-dinamize-automation-gerenciando-contatos/article/4000160765-como-integrar-sua-base-de-leads-e-clientes')"
        (keydown.enter)="redirectArticle('tour/4000178850-dinamize-automation-gerenciando-contatos/article/4000160765-como-integrar-sua-base-de-leads-e-clientes')"
        (keydown.space)="redirectArticle('tour/4000178850-dinamize-automation-gerenciando-contatos/article/4000160765-como-integrar-sua-base-de-leads-e-clientes')"
        class="button"
        tabindex="0"
        role="button"
        class="button"
      >
        <div class="box text-center div-tour">
          <div class="tour-number">2</div>
          <h3>Gerenciando contatos</h3>
        </div>
      </a>

      <a
        (click)="redirectArticle('/tour/4000178851-dinamize-automation-criando-um-email-marketing/article/4000175552-o-que-voce-precisa-saber-para-criar-seus-envios')"
        (keydown.enter)="redirectArticle('/tour/4000178851-dinamize-automation-criando-um-email-marketing/article/4000175552-o-que-voce-precisa-saber-para-criar-seus-envios')"
        (keydown.space)="redirectArticle('/tour/4000178851-dinamize-automation-criando-um-email-marketing/article/4000175552-o-que-voce-precisa-saber-para-criar-seus-envios')"
        class="button"
        tabindex="0"
        role="button"
        class="button"
      >
        <div class="box text-center div-tour">
          <div class="tour-number">3</div>
          <h3>Criando<br>envios</h3>
        </div>
      </a>

      <a
        (click)="redirectArticle('/tour/4000178852-dinamize-automation-configuracoes/article/4000172997-como-configurar-os-registros-dns')"
        (keydown.enter)="redirectArticle('/tour/4000178852-dinamize-automation-configuracoes/article/4000172997-como-configurar-os-registros-dns')"
        (keydown.space)="redirectArticle('/tour/4000178852-dinamize-automation-configuracoes/article/4000172997-como-configurar-os-registros-dns')"
        class="button"
        tabindex="0"
        role="button"
        class="button"
      >
        <div class="box text-center div-tour">
          <div class="tour-number">4</div>
          <h3>Configurando minha conta</h3>
        </div>
      </a>
    </div>
  </div>
</div>
